export const Off50YearlyOffer = 'specs.gg-ai-store.50OffYearlyOffer';
export const SelectThemeFirst = 'specs.gg-ai-store.selectThemeFirst';
export const DomainFlow = 'specs.gg-ai-store.domainFlow';
